import {
    getAllData,
} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    name: null,
    weight: null,
    semester_id: null,
    semester_name: null,
    type: null,
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "DESC",
    search: null,
    filter: null,
    semester: null
}
const initialState = () => ({
    data: {},
    rooms: [],
    msg: "Jaringan Bermasalah",
    status: 0,
    advisors: {},
    request: {...requestInit},
    item: {...itemInit},
    semester: [],
    blobData: null,
})

const state = initialState

const getters = {
    getData: state => state.data || {},
    getRooms: state => state.rooms || [],
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getActivitySemester: state => state.semester,
    getAdvisors: state => state.advisors,
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.msg
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_ROOMS(state, value) {
        state.rooms = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    SET_ACTIVITY_SEMESTER(state, value) {
        state.semester = value
    },
    SET_MYADVISOR(state, value) {
        state.advisors = value
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',value)
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    setAdvisors({commit}, value){
        commit('SET_MYADVISOR',value)
    },
    async getAllActivitySemester({commit, state}) {
        try {
            const response = await getAllData('/activity-semester', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_ACTIVITY_SEMESTER', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },

    async kampusMerdekaAdvisor({commit}, params) {
        try {
            /* params: { semester } */
            const response = await getAllData(`kampus-merdeka/myAdvisor`, params)
            commit('SET_RESPONSE', response.data)
            commit('SET_MYADVISOR', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async StudiIndependenAdvisor({commit}, params) {
        try {
            /* params: { semester } */
            const response = await getAllData(`kampus-merdeka/studiindependent/myAdvisor`, params)
            commit('SET_RESPONSE', response.data)
            commit('SET_MYADVISOR', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async ResearchAdvisor({commit, state}) {
        try {
            var response = await getAllData(`kampus-merdeka/research/myAdvisor`, state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_MYADVISOR', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllRoom({commit }, {date, session_id}) {
        try {
            var response = await getAllData(`session-room/${date}/${session_id}`)
            commit('SET_RESPONSE', response.data)
            commit('SET_ROOMS', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
